import { createAction } from "redux-actions";
import BalanceUsage from "../../Networking/API/BalanceUsage";
import LogIn from "../../Networking/API/LogIn";

const constants = {};

constants.BALANCE_USAGE_PENDING = "app/iotg/BALANCE_USAGE_PENDING";
constants.BALANCE_USAGE_SUCCESS = "app/iotg/BALANCE_USAGE_SUCCESS";
constants.BALANCE_USAGE_FAILURE = "app/iotg/BALANCE_USAGE_FAILURE";
constants.LOGIN_PENDING = "app/iotg/LOGIN_USAGE_PENDING";
constants.LOGIN_SUCCESS = "app/iotg/LOGIN_USAGE_SUCCESS";
constants.LOGIN_FAILURE = "app/iotg/LOGIN_USAGE_FAILURE";

const balanceUsagePending = createAction(constants.BALANCE_USAGE_PENDING);
const balanceUsageSuccess = createAction(constants.BALANCE_USAGE_SUCCESS);
const balanceUsageFailure = createAction(constants.BALANCE_USAGE_FAILURE);
const loginPending = createAction(constants.LOGIN_PENDING);
const loginSuccess = createAction(constants.LOGIN_SUCCESS);
const loginFailure = createAction(constants.LOGIN_FAILURE);

const TOURIST_DOMAINS = {
	prod: "mytravellerssim.telekom.gr",
	uat: "mytravelerssim-uat.telekom.gr",
	sit: "mytravelerssim-sit.telekom.gr",
};

const NO_TOURIST_DOMAINS = {
	prod: "iotgprepaid.telekom.gr",
	uat: "ciotgprepaid-uat.telekom.gr",
	sit: "ciotgprepaid-sit.telekom.gr",
};

const resolveEnvironment = (hostname) =>
	hostname.includes("-uat.")
		? "uat"
		: hostname.includes("-sit.")
			? "sit"
			: "prod";

const isTouristHostname = (hostname) =>
	Object.values(TOURIST_DOMAINS).includes(hostname);

/** @returns {boolean} true when a cross-domain redirect was started */
const redirectToMatchingDomain = (isTourist) => {
	if (process.env.NODE_ENV !== "production") return false;

	const { hostname, protocol, pathname, search, hash } = window.location;
	const env = resolveEnvironment(hostname);
	const onTouristHost = isTouristHostname(hostname);

	let targetDomain;
	if (isTourist) {
		if (onTouristHost) return false;
		targetDomain = TOURIST_DOMAINS[env];
	} else {
		targetDomain = NO_TOURIST_DOMAINS[env]?.trim();
		if (!targetDomain || !onTouristHost) return false;
	}

	if (hostname === targetDomain) return false;

	window.location.replace(
		`${protocol}//${targetDomain}${pathname}${search}${hash}`,
	);
	return true;
};

const loginUser = () => async (dispatch, getState) => {
	try {
		dispatch(loginPending());
		const response = await LogIn();
		if (response && response.data) {
			if (redirectToMatchingDomain(Boolean(response.data.isTourist))) {
				return;
			}
			dispatch(loginSuccess(response.data));
		}
		sessionStorage.setItem(
			"token",
			getState().BalanceReducer.payloadAfterLogIn.token,
		);
	} catch (e) {
		dispatch(loginFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const getBalanceUsage = () => async (dispatch) => {
	try {
		dispatch(balanceUsagePending());
		const response = await BalanceUsage();
		if (response && response.data) {
			dispatch(balanceUsageSuccess(response.data));
		}
	} catch (e) {
		dispatch(balanceUsageFailure());
		dispatch({
			type: "alert/OPEN_FAILURE",
			payload: "generalError",
		});
	}
};

const initialState = {
	loading: false,
	// we need the loginLoading because we want to redirect to the tourist iotg with a full screen loader in order to hide the inital landing page
	loginLoading: false,
	balanceUsageData: {},
	payloadAfterLogIn: {},
	errorLoginHandler: false,
	errorMessageHandler: false,
};

export const balanceActions = {
	getBalanceUsage,
	loginUser,
};

const BalanceReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case constants.LOGIN_PENDING:
			return {
				...state,
				loading: true,
				loginLoading: true,
				errorLoginHandler: false,
			};
		case constants.LOGIN_FAILURE:
			return {
				...state,
				loading: false,
				loginLoading: false,
				errorLoginHandler: true,
			};
		case constants.LOGIN_SUCCESS:
			return {
				...state,
				loading: false,
				loginLoading: false,
				payloadAfterLogIn: payload,
			};
		case constants.BALANCE_USAGE_PENDING:
			return { ...state, loading: true, errorMessageHandler: false };
		case constants.BALANCE_USAGE_FAILURE:
			return { ...state, loading: false, errorMessageHandler: true };
		case constants.BALANCE_USAGE_SUCCESS:
			return { ...state, loading: false, balanceUsageData: payload };
		default:
			return state;
	}
};

export default BalanceReducer;
